import React from "react";
import { css } from "@emotion/core";
import BeatLoader from "react-spinners/BeatLoader";
import PropTypes from "prop-types";

const override = css`
    display: block;
    margin: auto auto;
    border-color: var(--primary-color);
`;

interface PropsLoadingBar{
    loading?:boolean;
    fullscreen?:boolean;
}

export function LoadingBar(props: PropsLoadingBar)
{
    return (
        <div className="sweet-loading">
            <span style={{ fontFamily: "\"Segoe UI\", Arial, Helvetica, sans-serif" }} className={"loading" + (props.fullscreen === true ? " loading--fullscreen" : "")}>
                Loading...
                <BeatLoader  css={override}  color={"var(--primary-color)"} loading={props.loading} />
            </span>
            
        </div>
    );

}
     
LoadingBar.propTypes = {
    fullscreen: PropTypes.bool
}